function tbHandleizeShade(str) {
  return String(str || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function tbGetCartShadeName(item) {
  var colorNames = ['color', 'colour', 'couleur', 'colore', 'culoare', 'farbe', 'shade', '色', 'カラー', 'färg', 'farve'];
  var options = item.options_with_values || [];
  var i;

  for (i = 0; i < options.length; i++) {
    var name = (options[i].name || '').toLowerCase();
    if (colorNames.indexOf(name) !== -1 && options[i].value) {
      return options[i].value;
    }
  }

  for (i = 0; i < options.length; i++) {
    if (options[i].value && options[i].value !== 'Default Title') {
      return options[i].value;
    }
  }

  if (item.variant_title && item.variant_title !== 'Default Title') {
    return item.variant_title;
  }

  if (item.properties && item.properties.Concealer) {
    return item.properties.Concealer;
  }

  if (item.properties && item.properties.Foundation) {
    return item.properties.Foundation;
  }

  return '';
}

function tbIsMiniCartActive() {
  return $('#site-cart-sidebar').hasClass('tb-mini-cart');
}

function tbRefreshCartItemsFromSection() {
  if (window.TBMiniCart && typeof window.TBMiniCart.refresh === 'function') {
    return window.TBMiniCart.refresh();
  }

  return $.get('/?section_id=cart-helper').then(function (html) {
    var $doc = $('<div>').html(html);
    var $items = $doc.find('.cart-items');
    if ($items.length) {
      $('.cart-items').html($items.html());
    }
  });
}

function tbBuildCartShadeHTML(item) {
  var shadeName = tbGetCartShadeName(item);
  if (!shadeName || shadeName === 'Default Title') {
    return '';
  }

  var shadeHandle = tbHandleizeShade(shadeName);
  var shadeImageUrl =
    window.TB_SWATCHES &&
    (window.TB_SWATCHES[shadeHandle] || window.TB_SWATCHES[shadeName]);
  var swatchStyle;

  if (shadeImageUrl) {
    swatchStyle =
      'background-image:url(' +
      shadeImageUrl +
      '); background-size: cover; background-position: center;';
  } else {
    swatchStyle =
      'background-color:' + shadeName.toLowerCase().replace(/\s+/g, '') + ';';
  }

  return (
    '<span class="color-opt title">' +
    '<span class="color-opt-bgImg bg-img-default" style="' +
    swatchStyle +
    '" aria-hidden="true"></span>' +
    shadeName +
    '</span>'
  );
}

function refreshCart1(){
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      var cart_structure = "";
      var cart_structure1 = "";
      var empty_cart = " ";

   if(data.total_price == 0 ) {
     $('#CheckOut').addClass('checkout-disabled');
   }
      else{
         $('#CheckOut').removeClass('checkout-disabled');
      }
      
      if(data.item_count > 0) {
        $('.cart-heading').show();
        $('.empty-cart').hide();
        $('.bottom-content').show(); 
        $('.site-cart-heading').text(data.item_count+' PRODUCT IN YOUR CART');
        $('.cart__footer').removeClass().addClass('cart__footer');
//         $('#site-cart-sidebar').addClass('sidebar--opened');
//         $('#site-cart-sidebar').css('display','block');
//         $('body').addClass('sidebar-opened');
      }      
      else{
        $('.cart-heading').hide();
        $('.empty-cart').show();
        $('.bottom-content').hide();
        $('.site-cart-heading').text(data.item_count+' PRODUCT IN YOUR CART');
        $('.cart__footer').addClass('cart--empty');
      }



      $(data.items).each(function (ix, em){

        if(data.item_count > 0) {

          var elements = "<div>";
          if (data.item_count > 0) {
            elements += 'test';
          }
          elements += "</div>";


          var elements123 = "<div>";
          for(var key in em.properties) {
            //            var elements123 +=('key: ' + key + '\n' + 'value: ' + em.properties[key]);
            elements123 += "<div>"+ key +" : "+em.properties[key]+"</div>";

            var deodem = em.properties[key];			            
            if(deodem === "Bundle-Product"){
              var prm = deodem;
            }
            else{
              var prm = "";
            }
          }elements += "</div>";

          cart_structure += '<div class="cart-item ' +em.handle+'" data-title="'+em.handle+'" data-id="39741437378638:3a4d287232ccdc0d9b8674e956f4d699" data-variant="39741437378638" data-qty="1">'+
            '<div>'+
            '<a href="'+em.url+'" class="thumbnail">'+
            '<figure class="lazy-image  lazy-image--transparent " data-ratio="" style="padding-top: 130%">'+
            '<img src="'+ em.image +'?crop=center&amp;height=260&amp;v=1648906613&amp;width=200 260w" sizes="100px" class="img lazy" loading="lazy" width="326" height="391">'+
            '</figure>'+
            '</a>'+
            '<div class="content">'+
            '<a href="'+em.url+'">'+
            '<span class="title">'+em.product_title+'</span>' +
            tbBuildCartShadeHTML(em) +
            '</a><div class="price"><div class="item__properties">'+elements123+'</div></div>'+
             '<div class="item__price-list"><span class="item__price">₹ '+ parseFloat(em.final_price / 100) +'</span></div></div><div class="item__properties"></div>'+
            '<div class="quant-selector"><a  class="less" data-variantid="'+ em.variant_id + '"  href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0555/4018/7214/files/39384297500c145afa524e1721a04663.svg?v=1650276446"></a>'+
            '<input  class="qty js-qty" type="number" name="updates[]" value="' + em.quantity + '" min="0" aria-label="Quantity">'+
            '<a  class="more" data-variantid="'+ em.variant_id + '"  href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0555/4018/7214/files/18dddcc9cf53b547eaf0f76c308502f6_e2c6dbb9-0564-4b89-be39-282da393cb9c.svg?v=1650276446"></a></div>'+
            '</div>'+
            '</div>'+
            '<div class="actions">'+
            '<a href="#" class="remove" data-variantid="'+ em.variant_id + '" data-index="'+ix+'" title="Remove item from cart" aria-label="Remove item from cart" data-href="/cart/change?line=1&amp;quantity=0"><span aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41418 0L16.9705 15.5563L15.5563 16.9706L-2.89679e-05 1.41421L1.41418 0Z" fill="#111111"></path><path d="M16.9706 1.41431L1.41423 16.9707L1.85966e-05 15.5564L15.5564 9.31025e-05L16.9706 1.41431Z" fill="#111111"></path></svg></span></a>'+
            '</div></div>';

          cart_structure1 += '<li  class="cart_product " id="'+prm+'" data-pro_handle="' + em.url + '" data-variantid="' + em.variant_id + '"><div class="image-info"><div class="image"><img src="'+ em.image +'" width="90px"/></div><div class="product-information"><span> '+ em.title +' </span><span class="price">Price - '+ parseFloat(em.final_line_price / 100) +'</span><div class="qty-input bold js-cart-variant-update">\
<i class="less" data-variantid="'+ em.variant_id + '"> </i> <input class="js-qty" type="text" data-variantid="'+ em.variant_id + '" value="' + em.quantity + '"> <i class="more" data-variantid="'+ em.variant_id + '"></i>\
</div></div><div class="edit-product" data-variantid="'+ em.variant_id + '"><img src="https://cdn.shopify.com/s/files/1/0136/9754/8374/files/edit.svg?v=1637914055"></div><div class="remove-pro"><a href="#" class="remove-pro-cart" data-variantid="'+ em.variant_id + '" data-index="'+ix+'">remove</a></div></div></li>';                 
        }        
      });

      if (window.TBMiniCart && typeof window.TBMiniCart.syncTotals === 'function') {
        window.TBMiniCart.syncTotals(data);
      } else {
        $('[data-tb-mc-subtotal]').text('₹ ' + (data.items_subtotal_price / 100));
        $('[data-tb-mc-total]').text('₹ ' + (data.total_price / 100));
      }

      if (tbIsMiniCartActive()) {
        tbRefreshCartItemsFromSection().always(function () {
          if (typeof window.updateFreeGiftsText === 'function') {
            setTimeout(function () {
              window.updateFreeGiftsText();
            }, 150);
          }
        });
      } else {
        $('.cart-items').html(cart_structure);

        if (typeof window.updateFreeGiftsText === 'function') {
          setTimeout(function () {
            window.updateFreeGiftsText();
          }, 150);
        }
      }
      
      // Upsell products are now rendered via Liquid, no need to load

      $('.demo123').html(data.item_count);	         
    }
  });	


}
if (!tbIsMiniCartActive()) {
  refreshCart1();
}

// Debounce function to prevent multiple rapid calls
var refreshCartTimeout;
function refreshCart(forceFullRefresh){
  if (tbIsMiniCartActive()) {
    if (window.TBMiniCart && typeof window.TBMiniCart.refresh === 'function') {
      return window.TBMiniCart.refresh();
    }
    return;
  }

  // Clear any pending refresh
  clearTimeout(refreshCartTimeout);
  
  // Execute immediately if forced, otherwise debounce
  var executeRefresh = function() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(data) { 
        console.log('Cart refresh - items:', data.item_count, 'forceFullRefresh:', forceFullRefresh);
        
        // Only update totals and counts - don't rebuild entire cart HTML
        if(data.total_price == 0 ) {
          $('#CheckOut').addClass('checkout-disabled');
        } else {
          $('#CheckOut').removeClass('checkout-disabled');
        }
        
        // Update item count
        $('.site-cart-heading').text(data.item_count+' PRODUCT IN YOUR CART');
        $('.demo123').html(data.item_count);
        
        // Update totals
        if (window.TBMiniCart && typeof window.TBMiniCart.syncTotals === 'function') {
          window.TBMiniCart.syncTotals(data);
        } else {
          $('[data-tb-mc-subtotal]').text('₹ ' + (data.items_subtotal_price / 100));
          $('[data-tb-mc-total]').text('₹ ' + (data.total_price / 100));
        }
        
        // Update cart visibility
        if(data.item_count > 0) {
          $('.cart-heading').show();
          $('.empty-cart').hide();
          $('.bottom-content').show(); 
          $('.cart__footer').removeClass().addClass('cart__footer');
          $('#site-cart-sidebar').addClass('sidebar--opened');
          $('#site-cart-sidebar').css('display','block');
          $('body').addClass('sidebar-opened');
        } else {
          $('.cart-heading').hide();
          $('.empty-cart').show();
          $('.bottom-content').hide();
          $('.cart__footer').addClass('cart--empty');
        }
        
        // Rebuild cart HTML if forced OR if cart-items is empty (new item added)
        var currentItemCount = $('.cart-items .cart-item').length;
        var needsFullRefresh = forceFullRefresh || $('.cart-items').children().length === 0 || data.item_count !== currentItemCount;
        
        console.log('needsFullRefresh:', needsFullRefresh, 'currentItemCount:', currentItemCount, 'data.item_count:', data.item_count);
        
        if(needsFullRefresh) {
          if (tbIsMiniCartActive()) {
            tbRefreshCartItemsFromSection().always(function () {
              setTimeout(function () {
                if (typeof window.updateFreeGiftsText === 'function') {
                  window.updateFreeGiftsText();
                }
              }, 50);
            });
            return;
          }

          var cart_structure = "";
          if(data.items && data.items.length > 0) {
            $(data.items).each(function (ix, em){
              // Build properties HTML
              var propertiesHTML = "";
              if(em.properties) {
                for(var key in em.properties) {
                  var propertyFirstChar = key.charAt(0);
                  var shouldHide = !em.properties[key] || propertyFirstChar === '_';
                  propertiesHTML += '<div class="item__property' + (shouldHide ? ' hide' : '') + '">' +
                    '<span class="item__propety-label">' + key + ':</span>' +
                    '<span class="item__property-value">' + em.properties[key] + '</span>' +
                    '</div>';
                }
              }
              
              // Build data-title with variant title if applicable
              var dataTitle = em.product_title;
              if(em.variant_title && em.variant_title !== 'Default Title') {
                dataTitle += ' (' + em.variant_title + ')';
              }
              
              // Fix image URL - use the image URL as-is or construct properly
              var imageUrl = em.image;
              // If image already has query params, use as-is, otherwise add params
              if(imageUrl.indexOf('?') === -1) {
                imageUrl = imageUrl + '?crop=center&height=80&width=80';
              } else {
                // Image already has params, use as-is
                imageUrl = imageUrl;
              }
              
              var shadeHTML = tbBuildCartShadeHTML(em);

              cart_structure += '<div class="cart-item" data-title="' + dataTitle + '" data-id="' + em.key + '" data-variant="' + em.variant_id + '" data-qty="' + em.quantity + '">' +
                '<div>' +
                '<a href="' + em.url + '" class="thumbnail">' +
                '<figure class="lazy-image lazy-image--transparent" data-ratio style="padding-top: 100%">' +
                '<img src="' + imageUrl + '" alt="' + em.title + '" srcset="' + imageUrl + ' 80w" sizes="80px" class="img lazy" loading="lazy" width="80" height="80">' +
                '</figure>' +
                '</a>' +
                '<div class="content">' +
                '<a href="' + em.url + '">' +
                '<span class="title">' + em.product_title + '</span>' +
                shadeHTML +
                '</a>' +
                '<div class="price">' +
                '<div class="item__price-list">' +
                '<span class="item__price">₹ ' + parseFloat(em.final_price / 100) + '</span>' +
                '</div>' +
                '</div>' +
                '<div class="item__properties">' + propertiesHTML + '</div>' +
                '<div class="quant-selector">' +
                '<a class="less" data-variantid="' + em.variant_id + '" href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0555/4018/7214/files/39384297500c145afa524e1721a04663.svg?v=1650276446"></a>' +
                '<input class="qty js-qty" type="number" name="updates[]" value="' + em.quantity + '" min="0" aria-label="Quantity">' +
                '<a class="more" data-variantid="' + em.variant_id + '" href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0555/4018/7214/files/18dddcc9cf53b547eaf0f76c308502f6_e2c6dbb9-0564-4b89-be39-282da393cb9c.svg?v=1650276446"></a>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div class="actions">' +
                '<a href="/cart/change?line=' + (ix + 1) + '&quantity=0" class="remove" data-variantid="' + em.variant_id + '" data-index="' + ix + '" title="Remove item from cart" aria-label="Remove item from cart"><span aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41418 0L16.9705 15.5563L15.5563 16.9706L-2.89679e-05 1.41421L1.41418 0Z" fill="#111111"></path><path d="M16.9706 1.41431L1.41423 16.9707L1.85966e-05 15.5564L15.5564 9.31025e-05L16.9706 1.41431Z" fill="#111111"></path></svg></span></a>' +
                '</div>' +
                '</div>';
            });
          }
          $('.cart-items').html(cart_structure);
          console.log('Cart HTML rebuilt, items:', $('.cart-items .cart-item').length);
        } else {
          // Just update quantities in existing items
          $(data.items).each(function (ix, em){
            var $item = $('.cart-item[data-variant="'+em.variant_id+'"]');
            if($item.length) {
              $item.find('.js-qty').val(em.quantity);
              $item.attr('data-qty', em.quantity);
              $item.find('.item__price').text('₹ '+parseFloat(em.final_price / 100));
            }
          });
        }
        
        // Update gift progress bar after DOM is updated
        setTimeout(function() {
          if (typeof window.updateFreeGiftsText === 'function') {
            window.updateFreeGiftsText();
          }
        }, 50);
      },
      error: function(xhr, status, error) {
        console.error('Cart refresh error:', error);
      }
    });
  };
  
  // Execute immediately if forced, otherwise debounce
  if(forceFullRefresh) {
    executeRefresh();
  } else {
    refreshCartTimeout = setTimeout(executeRefresh, 100);
  }
}


function Samplecart(){
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) { 
      

   if(data.total_price == 0 ) {
     $('#CheckOut').addClass('checkout-disabled');
   }
      else{
         $('#CheckOut').removeClass('checkout-disabled');
      }
      
      if(data.item_count > 0) {
         if (data.total_price == 0)
         {
          
                 console.log('only sample item');
                 console.log(data);
                    $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    data: '',
                    dataType: 'json',
                    success: function() {
                    refreshCart(true); // Force full refresh
                    },
                    error: function(XMLHttpRequest, textStatus) {
                    /* error code */
                    }
                    });
               // setTimeout(function() { }, 2200);
         }
        
      }      
   
            
    }
  });	


}

// setInterval(function () { Samplecart(); }, 4500);


$(document).on('click', '.product-item__variant.tb-pcard__shade', function () {
  var $variant = $(this);
  var $root = $variant.closest('[data-pcard-root], .product-item');
  var id = $variant.attr('data-varid');
  if (id && $root.length) {
    $root.find('.item-varid').val(id);
  }
});

$(document).on('click','.col-add-btn',function(e){ 
  e.preventDefault();

  var $btn = $(this);
  if ($btn.data('atc-loading')) {
    return;
  }

  var $root = $btn.closest('[data-pcard-root], .product-item');
  var ID = $root.find('.product-item__variant.active').attr('data-varid');
  if (!ID) {
    ID = $btn.closest('form').find('input[name="id"], .item-varid').val();
  }

  if (!ID) {
    $('.outer-layer-no-select').fadeIn().delay(3000).fadeOut();
    return;
  }

  var originalHtml = $btn.html();
  var clearAtcLoading = function () {
    $btn.data('atc-loading', false);
    $btn.prop('disabled', false).removeClass('is-atc-loading').removeAttr('aria-busy');
    var orig = $btn.data('atc-original-html');
    if (orig != null) {
      $btn.html(orig);
    }
    $btn.removeData('atc-original-html');
  };

  $btn.data('atc-loading', true).data('atc-original-html', originalHtml);
  $btn.prop('disabled', true).addClass('is-atc-loading').attr('aria-busy', 'true');
  $btn.html('<span class="col-add-btn__spinner" aria-hidden="true"></span><span class="visually-hidden">Adding to cart</span>');

  var loadingSafety = setTimeout(clearAtcLoading, 15000);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity: 1, id: ID },
    dataType: 'json',
    success: function (data) {
      $('.site-cart-heading').text(data.quantity + ' PRODUCT IN YOUR CART');
      refreshCart(true);
      if (window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.schedule === 'function') {
        window.TBFreeGiftGuard.schedule();
      }
      var cartSidebar = document.getElementById('site-cart-sidebar');
      if (cartSidebar && typeof cartSidebar.show === 'function') {
        cartSidebar.show();
      } else if ($('#site-cart-sidebar').length) {
        $('#site-cart-sidebar').addClass('sidebar--opened').css('display', 'block');
        $('body').addClass('sidebar-opened');
      }
    },
    error: function (error) {
      console.error('Error:', error);
      $('.outer-layer-no-select').fadeIn().delay(3000).fadeOut();
      Samplecart();
    },
    complete: function () {
      clearTimeout(loadingSafety);
      clearAtcLoading();
    }
  });
});

 setInterval(function() {
  var elements = document.getElementsByClassName('color-opt');
      
      for(var i = 0; i<elements.length; i++){
      
      if(elements[i].innerText==='Default-Title' || elements[i].innerText==='Thuis'){
      elements[i].style.opacity = 0 ;
      elements[i].style.height = 0 ;
      
      }
      }
    
 }, 1000);

$(document).on('click','.col-add-bundle-btn',function(){ 
  event.preventDefault();
  
  var ID = $(this).parents('.product-item__caption').find('.product-item__variant.active').attr('data-varid');  
  
  console.log('Selected Variant Id: '+ID);
  
 var concealer_type = $('.shade-recommended').html();
 var foundation_type = $('.shade-recommended-fd').html();
 var primer_type = $('.active-bundle-pro .product-item__title span').text();
  
 let data = {
                    quantity:1,
                    id:ID,
                    properties: {
                      "Concealer": concealer_type,
                      "Foundation": foundation_type,
                      "Primer": primer_type,
                      "Makeup Bag" : ' '
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      $('.outer-layer-no-select').fadeIn().delay(3000).fadeOut();

    } 
  });
  

  }, 1000);
  
 
});

 
$(document).on('click','.product__add-to-cart', function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.selected-var').data('varid');   
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty);
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity:qty,
      id:ID
    },
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
       $('#quick-view-modal').removeClass('visible-modal')
      $('.page-overlay').removeClass('show-quickview-overlay')
      $('#quick-view-modal .quick-view-content-layout').html('');
      refreshCart(true); // Force full refresh after adding item
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});



$(document).on('click','.remove',function(e){ 
  if (tbIsMiniCartActive()) return;
  e.preventDefault();
  var variant_id = $(e.target).closest('.remove').attr("data-variantid");
  var data_attr_val = $(this).attr("data-index");
  var data_pro_index = parseInt(data_attr_val)+1;
  var $item = $(this).closest('.cart-item');
  
  // Optimistic UI update - remove immediately
  $item.fadeOut(200, function() {
    $(this).remove();
  });
  
  $.ajax({
    url: "/cart/change.js",
    data: {
      line: data_pro_index,
      quantity: 0
    },
    datatype:"JSON",
    method:"POST",
    success: function(data){
      refreshCart(false); // Don't rebuild, just update totals
    },
    error: function() {
      // On error, refresh to restore correct state
      refreshCart(true);
    }
  })
});


$(document).on('click','.cart-items .less',function(e){   
  if (tbIsMiniCartActive()) return;
  e.preventDefault();
  var variant_id = $(this).attr("data-variantid");
  var $input = $(this).parent().find('.js-qty');
  var quantity = parseInt($input.val()) - 1;
  
  if(quantity < 0) return;
  
  // Optimistic UI update
  $input.val(quantity);
  
  $.ajax({
    url: "/cart/change.js",
    data: {
      id: variant_id,
      quantity: quantity
    },
    datatype:"JSON",
    method:"POST",
    success: function(data){
      refreshCart(false); // Don't rebuild, just update totals
    },
    error: function() {
      // On error, refresh to restore correct state
      refreshCart(true);
    }
  })     
});


$(document).on('click','.cart-items .more',function(e){
  if (tbIsMiniCartActive()) return;
  e.preventDefault();
  var variant_id = $(this).attr("data-variantid");
  var $input = $(this).parent().find('.js-qty');
  var updated_val = parseInt($input.val()) + 1;
  
  // Optimistic UI update
  $input.val(updated_val);
  
  $.ajax({
    url: "/cart/change.js",
    data: {
      quantity: updated_val,
      id: variant_id
    },
    datatype:"JSON",
    method:"POST",
    success: function(data){
      refreshCart(false); // Don't rebuild, just update totals
    },
    error: function(error) { 
      console.error('Error:', error);
      // On error, refresh to restore correct state
      refreshCart(true);
      if(error.responseJSON && error.responseJSON.description) {
        alert(error.responseJSON.description);
      }
    }
  })         
});



  $(document).on('click','.product-variant__label',function(e){
//     alert('clicked');
   var var_id =  $(this).data('varid');
//     console.log(var_id);
    $('.product-variant__label').removeClass('selected-var');
   $(this).addClass('selected-var');
    
});

 $(document).on('click','.product-variant__label1',function(e){
//     alert('clicked');
   var var_id =  $(this).data('varid');
//     console.log(var_id);
    $('.product-variant__label1').removeClass('selected-var');
   $(this).addClass('selected-var');
    
});



 $(document).on('click','.product-variant__label2',function(e){
//     alert('clicked');
   var var_id =  $(this).data('varid');
//     console.log(var_id);
    $('.product-variant__label2').removeClass('selected-var');
   $(this).addClass('selected-var');
    
});
 
$(document).on('click','.product-variant__label3',function(e){
//     alert('clicked');
   var var_id =  $(this).data('varid');
//     console.log(var_id);
    $('.product-variant__label3').removeClass('selected-var');
   $(this).addClass('selected-var');
    
});

 $(document).on('click','.product-variant__label4',function(e){
//     alert('clicked');
   var var_id =  $(this).data('varid');
//     console.log(var_id);
    $('.product-variant__label4').removeClass('selected-var');
   $(this).addClass('selected-var');
    
});


$(document).on('click','.product__cart-actions .more',function(e){
//   var variant_id = $(this).attr("data-variantid");
  var current_val = $(this).prev(".js-qty").val(parseInt(jQuery(this).prev(".js-qty").val())+1);
  var updated_val =  $(this).parent().find('.js-qty').val() ;
  
});

$(document).on('click','.product__cart-actions .less',function(e){
 var old_val =  $(this).parent().find('.js-qty').val() ;
  if(old_val>1) {
  var current_val = $(this).next(".js-qty").val(parseInt(jQuery(this).next(".js-qty").val())-1);
  var updated_val =  $(this).parent().find('.js-qty').val() ;
  }
});



// Bundles products 
 setTimeout(function() {
$('.concealer-custom-shades .product-variant__input:checked').val();
console.log('found');
 $('.concealer-selected-shade span').html($('.concealer-custom-shades .product-variant__input').val());

$('.foundation-custom-shades .product-variant__input:checked').val();
console.log('found concealer');
 $('.foundation-selected-shade span').html($('.foundation-custom-shades .product-variant__input1:checked').val());

   
 }, 1000);

$(document).on('click','.concealer-custom-shades .product-variant__input',function(){
    console.log($(this).val());
    $('.concealer-selected-shade span').html($(this).val());
});
$(document).on('click','.product-top-grid .product-variant__input',function(){
    console.log($(this).val());
    $('.concealer-selected-shade span').html($(this).val());
});
$(document).on('click','.foundation-custom-shades .product-variant__input1',function(){
    console.log($(this).val());
    $('.foundation-selected-shade span').html($(this).val());
});

$(document).on('click','.foundation-custom-shades .product-variant__input1',function(){
    console.log($(this).val());
    $('.foundation-selected-shade span').html($(this).val());
});
$(document).on('click','.lustre_custom_shades_03 .product-variant__input2',function(){
    console.log($(this).val());
    $('.lusture-selected-shade-01 span').html($(this).val());
});
$(document).on('click','.lustre_custom_shades_04 .product-variant__input3',function(){
    console.log($(this).val());
    $('.lusture-selected-shade-02 span').html($(this).val());
});


$(document).on('click','.product__add-to-cart-bundle',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

    var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
    var primer_select = $('#primer-select').val();
  
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty+'selected_concealer '+ selected_concealer+' '+concealer_selected_shade+' selected foundation '+foundation_select +''+foundation_selected_shade+' primer_select: '+primer_select);

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "Concealer": selected_concealer +' - '+ concealer_selected_shade,
                      "Foundation" : foundation_select+' -  '+ foundation_selected_shade,
                      "Primer" : primer_select,
                      "Makeup Bag" : ' '
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});




$(document).on('click','.product__add-to-cart-bundlee',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
 

    var foundation_select = $('#foundation-select').val();
  
  
    var primer_select = $('#primer-select').val();
  var primer_selectt = $('#primer-selectt').val();
  
  var qty = $('.product__quantity').val();

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "First Primer": 'OVER DEW PLUMPING PRIMER',
                      "Second Primer" : 'CALM ON HYDRATING GEL PRIMER',
                      "Third Primer" : 'MATTE UP BALANCING PRIMER',
                      "Fourth Primer" : 'GET EVEN MOISTURIZING PRIMER'
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});








$(document).on('click','.product__add-to-cart-bundle-vl',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

    var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
    var primer_select = $('#primer-select').val();
  
  var lustre_custom_shades_03 =  $('.lusture-selected-shade-01 span').html();

  var lustre_select = $('#lustre-select').val();
  
  var lustre_custom_shades_04 =  $('.lusture-selected-shade-02 span').html();
  
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty+'selected_concealer '+ selected_concealer+' '+concealer_selected_shade+' selected foundation '+foundation_select +''+foundation_selected_shade+' lustre_select 1: '+primer_select + '' +lustre_custom_shades_03+' lusture select 2'+ lustre_select + '' +lustre_custom_shades_04 );

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "Lustre 1": selected_concealer +' - '+ concealer_selected_shade,
                      "Lustre 2" : foundation_select+' -  '+ foundation_selected_shade,
                      "Lustre 3" : primer_select+' - ' + lustre_custom_shades_03,
                      "Lustre 4" : lustre_select+' - ' + lustre_custom_shades_04
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});








$(document).on('click','.product__add-to-cart-diwali',function(){
 event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();  
 var selected_concealer = $('.big-select:eq(0)').find('.side-selects:visible option:selected').text();
var foundation_select = $('.big-select:eq(1)').find('.side-selects:visible option:selected').text();
var primer_select = $('.big-select:eq(2)').find('.side-selects:visible option:selected').text();

var concealer_selected_shade = $('.big-select:eq(0)').find('.selected-var').closest('.product-variant__item').find('input').val();
var foundation_selected_shade = $('.big-select:eq(1)').find('.selected-var').closest('.product-variant__item').find('input').val();
var lustre_custom_shades_03 = $('.big-select:eq(2)').find('.selected-var').closest('.product-variant__item').find('input').val();

let data = {
    quantity: '1',
    id: ID,
    properties: {
        "Product 1": selected_concealer + ' - ' + concealer_selected_shade,
        "Product 2": foundation_select + ' - ' + foundation_selected_shade,
        "Product 3": primer_select + ' - ' + lustre_custom_shades_03
    }
}
   console.log(data);
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
});


$(document).on('click','.product__add-to-cart-bundle-vb',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

    var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
    var primer_select = $('#primer-select').val();
  
  var lustre_custom_shades_03 =  $('.lusture-selected-shade-01 span').html();

  var lustre_select = $('#lustre-select').val();
  
  var lustre_custom_shades_04 =  $('.lusture-selected-shade-02 span').html();
  
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty+'selected_concealer '+ selected_concealer+' '+concealer_selected_shade+' selected foundation '+foundation_select +''+foundation_selected_shade+' lustre_select 1: '+primer_select + '' +lustre_custom_shades_03+' lusture select 2'+ lustre_select + '' +lustre_custom_shades_04 );

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "SHADE 1": selected_concealer +' - '+ concealer_selected_shade,
                      "SHADE 2" : foundation_select+' -  '+ foundation_selected_shade,
                      "SHADE 3" : primer_select+' - ' + lustre_custom_shades_03
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});








$(document).on('click','.product__add-to-cart-bundle-vglow',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

    var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
    var primer_select = $('#primer-select').val();
  
  var lustre_custom_shades_03 =  $('.lusture-selected-shade-01 span').html();

  var lustre_select = $('#lustre-select').val();
  
  var lustre_custom_shades_04 =  $('.lusture-selected-shade-02 span').html();
  
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty+'selected_concealer '+ selected_concealer+' '+concealer_selected_shade+' selected foundation '+foundation_select +''+foundation_selected_shade+' lustre_select 1: '+primer_select + '' +lustre_custom_shades_03+' lusture select 2'+ lustre_select + '' +lustre_custom_shades_04 );

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "SHADE 2" : foundation_select+' -  '+ foundation_selected_shade,
                      "SHADE 3" : primer_select+' - ' + lustre_custom_shades_03
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});









$(document).on('click','.product__add-to-cart-bundle-kk',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

    var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
    var primer_select = $('#primer-select').val();
  
  var lustre_custom_shades_03 =  $('.lusture-selected-shade-01 span').html();

  var lustre_select = $('#lustre-select').val();
  
  var lustre_custom_shades_04 =  $('.lusture-selected-shade-02 span').html();
  
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty+'selected_concealer '+ selected_concealer+' '+concealer_selected_shade+' selected foundation '+foundation_select +''+foundation_selected_shade+' lustre_select 1: '+primer_select + '' +lustre_custom_shades_03+' lusture select 2'+ lustre_select + '' +lustre_custom_shades_04 );

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "Selected Product": selected_concealer +' - '+ concealer_selected_shade
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});







// Sample bundle Get Even

$(document).on('click','.product__add-to-cart-bundle-sample1',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

    var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
    var primer_select = $('#primer-select').val();
  
  var lustre_custom_shades_03 =  $('.lusture-selected-shade-01 span').html();

  var lustre_select = $('#lustre-select').val();
  
  var lustre_custom_shades_04 =  $('.lusture-selected-shade-02 span').html();
  
  var qty = $('.product__quantity').val();
  console.log('Selected ID: '+ID+' Quanity: '+qty+'selected Shade 1 '+concealer_selected_shade+' selected shade 2'+foundation_selected_shade+' selected shade 3: ' +lustre_custom_shades_03);

  let data = {
                    quantity:qty,
                    id:ID,
                    properties: {
                      "Sample 1":concealer_selected_shade,
                      "Sample 2" : foundation_selected_shade,
                      "Sample 3" : lustre_custom_shades_03
                    }
                  }
  
  setTimeout(function() {
        $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (data) { 
      $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
      refreshCart(true); // Force full refresh when adding new items
    },
    error : function (error) { 
      console.error('Error:', error);
      alert(error.responseJSON.description);

    } 
  });
  

  }, 1000);
  
 
});

// Concealer + Foundation Combo - Shades are now hardcoded in HTML

// Concealer + Foundation Combo Add to Cart Handler
$(document).on('click','.product__add-to-cart-bundle-cf',function(){ 
  event.preventDefault();
  var ID = $(this).parents().find('.item-varid').val();   
  var selected_concealer = $('#concealer-select').val();
  var concealer_selected_shade =  $('.concealer-selected-shade span').html();

  var foundation_select = $('#foundation-select').val();
  var foundation_selected_shade =  $('.foundation-selected-shade span').html();
  
  var qty = $('.product__quantity').val();
  console.log('Concealer Foundation Combo - Selected ID: '+ID+' Quantity: '+qty+' Concealer: '+ selected_concealer+' Shade: '+concealer_selected_shade+' Foundation: '+foundation_select +' Shade: '+foundation_selected_shade);

  // Validate selections
  if (!concealer_selected_shade || concealer_selected_shade.trim() === '') {
    alert('Please select a concealer shade');
    return;
  }
  
  if (!foundation_selected_shade || foundation_selected_shade.trim() === '') {
    alert('Please select a foundation shade');
    return;
  }

  let data = {
    quantity: qty,
    id: ID,
    properties: {
      "Concealer": selected_concealer +' - '+ concealer_selected_shade,
      "Foundation": foundation_select+' - '+ foundation_selected_shade
    }
  }
  
  setTimeout(function() {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json', 
      success: function (data) { 
        $('.site-cart-heading').text(data.quantity+' PRODUCT IN YOUR CART');
        refreshCart(true); // Force full refresh when adding new items
        // Open cart sidebar if using overlay
        if (typeof document.getElementById('site-cart-sidebar') !== 'undefined' && document.getElementById('site-cart-sidebar')) {
          document.getElementById('site-cart-sidebar').show();
        }
      },
      error : function (error) { 
        console.error('Error:', error);
        alert(error.responseJSON ? error.responseJSON.description : 'Error adding to cart');
      } 
    });
  }, 1000);
});





// // Sample Addon Get Even Foundation
//  $(document).on('click','.product__add-to-cart_v1',function(){ 
//   console.log('clicked sample btn');
//   var ID1 = 40191015911502;   
//   var qty = 1 ;
//   console.log('Selected ID: '+ID1+' Quanity: '+qty + 'Sample ATC added');
//  let data = {
//                     quantity:1,
//                     id:40191015911502,
//             }
// $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: { 
//         quantity: 1,
//         id: 40191015911502
//         },
//         dataType: 'json',
//         success: function(stuff) {
          
//          refreshCart();
//           // alert('sample added');
//           console.log(stuff);
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//         alert(textStatus, errorThrown);
//         }
//         });	
//      setTimeout(function() {
//       $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(data) { 
//         console.log(data);
//         $(data.items).each(function (ix, em){
//              console.log('variant id: '+em.id)
//              if(em.id == 40191015911502 ){
//                // alert('Sample Found');
//                if (em.quantity>1){
//                // alert('Sample QTY: '+em.quantity);
//                   setTimeout(function() {
//                  $.ajax({
//                   type: 'POST',
//                    url: '/cart/update.js',
//                   data: { updates: {40191015911502:0} },
//                   dataType: 'json',
//                   success: function(stuff) {
//                     console.log('Sample Removed');
//                    // refreshCart();
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                   }, 900);
//                 setTimeout(function() {
//                   $.ajax({
//                   type: 'POST',
//                   url: '/cart/add.js',
//                   data: { 
//                   quantity: 1,
//                   id: 40191015911502
//                   },
//                   dataType: 'json',
//                   success: function(stuff) {
//                   console.log('Sample Updated');
//                   refreshCart();
//                   // alert('sample added');
//                   console.log(stuff);
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                     }, 1500);
//                                   }
//                            }
//            });
//                refreshCart();
//                    }
//       });	
//       }, 700);
   
 
   
   
//  });

// // Sample Addon Matte up Foundation
//  $(document).on('click','.product__add-to-cart_v2',function(){ 
//   console.log('clicked sample btn');
//   var ID1 = 40191037571150;   
//   var qty = 1 ;
//   console.log('Selected ID: '+ID1+' Quanity: '+qty + 'Sample ATC added');
//  let data = {
//                     quantity:1,
//                     id:40191037571150,
//             }
// $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: { 
//         quantity: 1,
//         id: 40191037571150
//         },
//         dataType: 'json',
//         success: function(stuff) {
          
//          refreshCart();
//           // alert('sample added');
//           console.log(stuff);
         
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//         alert(textStatus, errorThrown);
//         }
//         });	
//      setTimeout(function() {
//       $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(data) { 
//         console.log(data);
//         $(data.items).each(function (ix, em){
//              console.log('variant id: '+em.id)
//              if(em.id == 40191037571150 ){
//                // alert('Sample Found');
//                if (em.quantity>1){
//                // alert('Sample QTY: '+em.quantity);
//                   setTimeout(function() {
//                  $.ajax({
//                   type: 'POST',
//                    url: '/cart/update.js',
//                   data: { updates: {40191037571150:0} },
//                   dataType: 'json',
//                   success: function(stuff) {
//                     console.log('Sample Removed');
//                    // refreshCart();
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                   }, 700);
//                 setTimeout(function() {
//                   $.ajax({
//                   type: 'POST',
//                   url: '/cart/add.js',
//                   data: { 
//                   quantity: 1,
//                   id: 40191037571150
//                   },
//                   dataType: 'json',
//                   success: function(stuff) {
//                   console.log('Sample Updated');
//                   refreshCart();
//                   // alert('sample added');
//                   console.log(stuff);
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                     }, 1300);
//                                   }
//                            }
//            });
//                refreshCart();
//                    }
//       });	
//       }, 700);
   
 
   
   
//  });

//  // Sample Addon Calm On Foundation
//  $(document).on('click','.product__add-to-cart_v3',function(){ 
//   console.log('clicked sample btn');
//   var ID1 = 40191039438926;   
//   var qty = 1 ;
//   console.log('Selected ID: '+ID1+' Quanity: '+qty + 'Sample ATC added');
//  let data = {
//                     quantity:1,
//                     id:40191039438926,
//             }
// $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: { 
//         quantity: 1,
//         id: 40191039438926
//         },
//         dataType: 'json',
//         success: function(stuff) {
          
//          refreshCart();
//           // alert('sample added');
//           console.log(stuff);
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//         alert(textStatus, errorThrown);
//         }
//         });	
//      setTimeout(function() {
//       $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(data) { 
//         console.log(data);
//         $(data.items).each(function (ix, em){
//              console.log('variant id: '+em.id)
//              if(em.id == 40191039438926 ){
//                // alert('Sample Found');
//                if (em.quantity>1){
//                // alert('Sample QTY: '+em.quantity);
//                   setTimeout(function() {
//                  $.ajax({
//                   type: 'POST',
//                    url: '/cart/update.js',
//                   data: { updates: {40191039438926:0} },
//                   dataType: 'json',
//                   success: function(stuff) {
//                     console.log('Sample Removed');
//                    // refreshCart();
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                   }, 700);
//                 setTimeout(function() {
//                   $.ajax({
//                   type: 'POST',
//                   url: '/cart/add.js',
//                   data: { 
//                   quantity: 1,
//                   id: 40191039438926
//                   },
//                   dataType: 'json',
//                   success: function(stuff) {
//                   console.log('Sample Updated');
//                   refreshCart();
//                   // alert('sample added');
//                   console.log(stuff);
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                     }, 1300);
//                                   }
//                            }
//            });
//                refreshCart();
//                    }
//       });	
//       }, 700);
   
 
   
   
//  });

//   // Sample Addon De Crease Foundation
//  $(document).on('click','.product__add-to-cart_v4',function(){ 
//   console.log('clicked sample btn');
//   var ID1 = 40191042715726;   
//   var qty = 1 ;
//   console.log('Selected ID: '+ID1+' Quanity: '+qty + 'Sample ATC added');
//  let data = {
//                     quantity:1,
//                     id:40191042715726,
//             }
// $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: { 
//         quantity: 1,
//         id: 40191042715726
//         },
//         dataType: 'json',
//         success: function(stuff) {
          
//          refreshCart();
//           // alert('sample added');
//           console.log(stuff);
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//         alert(textStatus, errorThrown);
//         }
//         });	
//      setTimeout(function() {
//       $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(data) { 
//         console.log(data);
//         $(data.items).each(function (ix, em){
//              console.log('variant id: '+em.id)
//              if(em.id == 40191042715726 ){
//                // alert('Sample Found');
//                if (em.quantity>1){
//                // alert('Sample QTY: '+em.quantity);
//                   setTimeout(function() {
//                  $.ajax({
//                   type: 'POST',
//                    url: '/cart/update.js',
//                   data: { updates: {40191042715726:0} },
//                   dataType: 'json',
//                   success: function(stuff) {
//                     console.log('Sample Removed');
//                    // refreshCart();
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                   }, 700);
//                 setTimeout(function() {
//                   $.ajax({
//                   type: 'POST',
//                   url: '/cart/add.js',
//                   data: { 
//                   quantity: 1,
//                   id: 40191042715726
//                   },
//                   dataType: 'json',
//                   success: function(stuff) {
//                   console.log('Sample Updated');
//                   refreshCart();
//                   // alert('sample added');
//                   console.log(stuff);
//                   },
//                   error: function(jqXHR, textStatus, errorThrown) {
//                   alert(textStatus, errorThrown);
//                   }
//                   });	
//                     }, 1300);
//                                   }
//                            }
//            });
//                refreshCart();
//                    }
//       });	
//       }, 700);
   
 
   
   
//  });
// Upsell Slider Functionality
$(document).ready(function() {
  function initUpsellSlider() {
    var $slider = $('.upsell-products-slider');
    var $prevBtn = $('.upsell-slider-prev');
    var $nextBtn = $('.upsell-slider-next');
    
    if (!$slider.length || !$prevBtn.length || !$nextBtn.length) {
      console.log('Upsell slider elements not found');
      return;
    }
    
    var itemWidth = 115; // 100px + 15px gap
    var visibleItems = 3;
    var scrollAmount = itemWidth * visibleItems;
    var isScrolling = false;
    
    function updateSliderButtons() {
      if (!$slider.length) return;
      
      var scrollLeft = $slider.scrollLeft();
      var scrollWidth = $slider[0].scrollWidth;
      var clientWidth = $slider.outerWidth();
      var maxScroll = scrollWidth - clientWidth;
      
      // Only update if we have valid dimensions
      if (scrollWidth <= 0 || clientWidth <= 0) {
        // Keep buttons enabled if dimensions aren't ready
        $prevBtn.removeClass('disabled').css({ 'opacity': '1' });
        $nextBtn.removeClass('disabled').css({ 'opacity': '1' });
        return;
      }
      
      // Update prev button
      if (scrollLeft <= 1) {
        $prevBtn.addClass('disabled').css({ 'opacity': '0.5' });
      } else {
        $prevBtn.removeClass('disabled').css({ 'opacity': '1' });
      }
      
      // Update next button - only disable if we're truly at the end
      // Add a buffer to account for rounding issues
      // Also check if there's actually more content to scroll
      if (maxScroll <= 0 || scrollLeft >= maxScroll - 10) {
        $nextBtn.addClass('disabled').css({ 'opacity': '0.5' });
      } else {
        $nextBtn.removeClass('disabled').css({ 'opacity': '1' });
      }
    }
    
    // Remove existing handlers
    $prevBtn.off('click.upsell');
    $nextBtn.off('click.upsell');
    
    // Add click handlers with namespace
    $prevBtn.on('click.upsell', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (isScrolling || $(this).hasClass('disabled')) {
        return false;
      }
      
      isScrolling = true;
      var currentScroll = $slider.scrollLeft();
      var newScroll = Math.max(0, currentScroll - scrollAmount);
      
      $slider.animate({ scrollLeft: newScroll }, 300, function() {
        isScrolling = false;
        updateSliderButtons();
      });
      
      return false;
    });
    
    $nextBtn.on('click.upsell', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Don't check disabled class - let the scroll happen and update after
      if (isScrolling) {
        return false;
      }
      
      isScrolling = true;
      var currentScroll = $slider.scrollLeft();
      var scrollWidth = $slider[0].scrollWidth;
      var clientWidth = $slider.outerWidth();
      var maxScroll = scrollWidth - clientWidth;
      var newScroll = Math.min(maxScroll, currentScroll + scrollAmount);
      
      // If we're already at or near the end, don't scroll
      if (currentScroll >= maxScroll - 5) {
        isScrolling = false;
        updateSliderButtons();
        return false;
      }
      
      $slider.animate({ scrollLeft: newScroll }, 300, function() {
        isScrolling = false;
        updateSliderButtons();
      });
      
      return false;
    });
    
    // Update on scroll
    $slider.off('scroll.upsell').on('scroll.upsell', updateSliderButtons);
    
    // Initial update - start with buttons enabled
    $prevBtn.removeClass('disabled').css({ 'opacity': '1' });
    $nextBtn.removeClass('disabled').css({ 'opacity': '1' });
    
    // Wait for layout to settle, then update button states
    // Check multiple times to ensure accurate calculation
    setTimeout(function() {
      updateSliderButtons();
    }, 300);
    
    setTimeout(function() {
      updateSliderButtons();
    }, 800);
    
    setTimeout(function() {
      updateSliderButtons();
    }, 1500);
    
    // Also update on window resize
    $(window).on('resize.upsell', function() {
      setTimeout(updateSliderButtons, 100);
    });
    
    // Update when images load (in case images affect layout)
    $slider.find('img').on('load', function() {
      setTimeout(updateSliderButtons, 100);
    });
  }
  
  // Initialize on page load
  setTimeout(initUpsellSlider, 500);
  
      // Re-initialize after cart updates (only if needed, debounced)
  var sliderInitTimeout;
  $(document).on('cart:updated cart:refresh', function() {
    clearTimeout(sliderInitTimeout);
    sliderInitTimeout = setTimeout(initUpsellSlider, 1000);
  });
  
  // Also try to initialize when cart form is loaded
  $(document).on('DOMContentLoaded', initUpsellSlider);
});
